import { render, staticRenderFns } from "./ElasticOrderEntry.vue?vue&type=template&id=deffda44&"
import script from "./ElasticOrderEntry.vue?vue&type=script&lang=js&"
export * from "./ElasticOrderEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports